import React, { useContext } from "react";
import AuthContext from "../firebase/auth-context/provider";
import StackdriverErrorReporter from "stackdriver-errors-js";
function Stackdriver(_ref) {
    var children = _ref.children;
    var user = useContext(AuthContext)[0].user;
    var errorHandler = new StackdriverErrorReporter();
    errorHandler.start({
        key: "AIzaSyA9NYRpYozVuYXaJiBFnYxaz80c2ZEQvI4",
        projectId: "makroskop-b14f3",
        context: {
            user: user
        }
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
}
export default Stackdriver;
